import { ChatTabTypes } from "../types/types";

export const setActiveChat = (value: any) => ({
  type: "SET_ACTIVE_CHAT",
  payload: value,
});

export const setListPagination = (value: {
  pageNumber: number;
  stopLoading?: boolean;
}) => ({
  type: "SET_PAGING_SIZE",
  payload: {
    pageNumber: value.pageNumber,
    stopLoading: value?.stopLoading,
  },
});

export const setGroupParticipantsPaging = (value: {
  pageNumber: number;
  stopLoading?: boolean;
}) => ({
  type: "SET_GROUP_PARTICIPANTS_PAGING_SIZE",
  payload: {
    pageNumber: value.pageNumber,
    stopLoading: value?.stopLoading,
  },
});



export const setInstanceList = (value: any) => ({
  type: "SET_INSTANCE_LIST",
  payload: value,
});

export const setInstanceContacts = (value: any) => ({
  type: "SET_VENDOR_LIST",
  payload: value,
});

export const setForwardContacts = (value: any) => ({
  type: "SET_FORWARD_LIST",
  payload: value,
});

export const setUserInfo = (value: any) => ({
  type: "SET_USER_INFO",
  payload: value,
});

export const setSpeedFiles = (value: any) => ({
  type: "SET_SPEED_FILES",
  payload: value,
});


export const setActiveVendor = (value: any) => ({
  type: "SET_ACTIVE_VENDOR",
  payload: value,
});

export const setLoadingForMore = (value: boolean) => ({
  type: "SET_LOADING",
  payload: value,
});


export const setCompany = (value: any) => ({
  type: "SET_COMPANY",
  payload: value,
});